import Vue from "vue";
export const EventBusEvents = {
  OpenSignupPleaseModal: "open-signup-please-modal",
  OpenSignupModal: "open-signup-modal",
};
export const EventBus = new Vue();
